import { VatModeEnum } from "~/typings/types";

const vatModeSelfEmployed = [VatModeEnum.NPD];
const vatModeIndividualEntrepreneur = [VatModeEnum.NPD, VatModeEnum.ORN, VatModeEnum.USN, VatModeEnum.AUSN, VatModeEnum.PSN, VatModeEnum.ESHN];
const vatModeCompany = [VatModeEnum.USN, VatModeEnum.ESHN, VatModeEnum.ORN];

const optionsVatMode = [
	{ label: 'НПД (Налог на профессиональный доход)', value: VatModeEnum.NPD },
	{ label: 'ОСН (Общая система налогообложения)', value: VatModeEnum.ORN },
	{ label: 'УСН (Упрощённая система налогообложения)', value: VatModeEnum.USN },
	{ label: 'АУСН (Автоматизированная упрощённая система)', value: VatModeEnum.AUSN },
	{ label: 'ПСН (Патентная система налогообложения)', value: VatModeEnum.PSN },
	{ label: 'ЕСХН (Единый сельскохозяйственный налог)', value: VatModeEnum.ESHN },
];

function getVatModeOptions(allowedModes: VatModeEnum[]): typeof optionsVatMode {
	return optionsVatMode.filter(option => allowedModes.includes(option.value));
}

export const optionsVatModeForSelfEmployed = getVatModeOptions(vatModeSelfEmployed);
export const optionsVatModeForIndividualEntrepreneur = getVatModeOptions(vatModeIndividualEntrepreneur);
export const optionsVatModeForCompany = getVatModeOptions(vatModeCompany);
